import { useSignals } from "@preact/signals-react/runtime";
import { StatusDto } from "../../../../../enums/Domain/Status";
import { IPicklistItem } from "../../../List/DisposalsPickList";
import SidePanelDisposalPickingItemInputs from "../components/SidePanelDisposalPickingItemInputs";
import { IDisposalCheck } from "./SidePanelDisposalPickList";
import DisposalPickingButtons from "../../../picking/DisposalPickingButtons";
import useDisposalPickListActions from "../../../picking/useDisposalPickListActions";

interface ISidePanelPickListItem {
    disposalId: string | undefined,
    selectedItem: IPicklistItem,
    items: IPicklistItem[],
    handleChange: (input: string) => (id: string, x: string | number | boolean | StatusDto) => void;
    minimumDisposalCheckCount: number,
    currentDisposalChecks: IDisposalCheck[],
    maxBoxCountForOnDemandDisposal: number,
    onSave?: () => Promise<void>,
    onSubmit?: () => Promise<void>
}

export default function SidePanelDisposalPickListItem({ disposalId, selectedItem, items, handleChange, minimumDisposalCheckCount, currentDisposalChecks, maxBoxCountForOnDemandDisposal, onSave, onSubmit }: ISidePanelPickListItem) {
    useSignals();
    const { save: saveAction, submit: submitAction, cancel } = useDisposalPickListActions({
        disposalId,
        items,
        maxBoxCountForOnDemandDisposal
    });

    const save = async () => {
        if (onSave) {
            await onSave();
        } else {
            await saveAction();
        }
    };

    const submit = async () => {
        if (onSubmit) {
            await onSubmit();
        } else {
            await submitAction();
        }
    };

    return (<div className="display--flex flex__direction--column height--full">
        <SidePanelDisposalPickingItemInputs data={selectedItem} handleChange={handleChange} />
        <DisposalPickingButtons
            save={save}
            submit={submit}
            cancel={cancel}
            lineItems={items}
            minimumDisposalCheckCount={minimumDisposalCheckCount}
            currentDisposalChecks={currentDisposalChecks}
        />
    </div>)
}